module.exports = __webpack_public_path__ + "img/johnston-logo-dark.ed75c62a.png";